<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-extra-large"
    title="インターネットType4・セキュリティアプライアンス契約変更"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <cross-validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-4">
            <div class="modal-body">
              <v-card variant="outlined" class="mx-4 mb-4">
                <v-card-text>
                  <div class="pa-4">
                    <v-row>
                      <v-col cols="6">
                        <app-label-group label="回線番号(メイン)">
                          <template #value>
                            <span class="ml-3">
                              {{
                                `${selectedItem.wnumberMainAct}/${selectedItem.wnumberMainSby}`
                              }}
                              [{{
                                $filter.enumTo(
                                  selectedItem.mainSite,
                                  "mainSite"
                                )
                              }}]
                            </span>
                          </template>
                        </app-label-group>
                      </v-col>
                      <v-col cols="6">
                        <app-label-group label="回線番号(BCP)">
                          <template #value>
                            <span class="ml-3">
                              {{
                                `${selectedItem.wnumberBcpAct}/${selectedItem.wnumberBcpSby}`
                              }}
                              [{{
                                $filter.enumTo(
                                  selectedItem.mainSite === "TOKYO"
                                    ? "OSAKA"
                                    : "TOKYO",
                                  "mainSite"
                                )
                              }}]
                            </span>
                          </template>
                        </app-label-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <app-label-group
                          label="VPN/VNコード"
                          :value="
                            selectedItem.vpnVnCode.charAt(0) !== 'B'
                              ? `${selectedItem.vpnVnCode}(${selectedItem.vnName})`
                              : selectedItem.vpnVnCode
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <app-label-group
                          label="メインサイト"
                          :value="
                            $filter.enumTo(selectedItem.mainSite, 'mainSite')
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <app-label-group
                          label="Type4ID"
                          :value="selectedItem.type4Id"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          name="type4Name"
                          v-model="form.type4Name"
                          label="Type4名"
                          :rules="{
                            required: true,
                            max: { length: 20 },
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-label-group>
                            <template #label>
                              <app-badge
                                item="Type4名"
                                :msg="
                                  $filter.message('info_max_length', {
                                    maxLength: '20',
                                  })
                                "
                                placement="end"
                              />
                            </template>
                            <template #value>
                              <app-form-input
                                class="ml-3"
                                v-bind="componentField"
                                :error-messages="errorMessage"
                                :field-meta="meta"
                              />
                            </template>
                          </app-label-group>
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
              </v-card>
              <v-card variant="outlined" class="main-card mx-4 mb-4">
                <v-card-title class="py-0 screen-title px-2 ma-4">
                  セキュリティアプライアンス契約変更
                </v-card-title>
                <v-card-text>
                  <div class="pa-4">
                    <v-row>
                      <v-col>
                        <v-radio-group
                          v-model="form.securityAppliance"
                          hide-details
                          density="comfortable"
                        >
                          <v-radio
                            label="UTM(1Gbpsベストエフォート)"
                            value="UTM_BEST_EFFORT"
                          />
                          <v-radio
                            label="インターネットFW(100Mbpsベストエフォート)"
                            value="IFW"
                          />
                          <div
                            class="d-flex flex-wrap align-start justify-start"
                          >
                            <template
                              v-if="
                                type4Options.bandwidthType !== 'NO_SECURING'
                              "
                            >
                              <v-radio
                                class="v-col-3 pa-0"
                                label="UTM(帯域確保型)"
                                value="UTM_SECURING"
                              />
                              <template
                                v-if="form.securityAppliance === 'UTM_SECURING'"
                              >
                                <validation-provider
                                  name="bandwidth"
                                  v-model.number="form.bandwidth!.value"
                                  label="利用帯域"
                                  :rules="{ required_num: true }"
                                  v-slot="{
                                    componentField,
                                    errorMessage,
                                    meta,
                                  }"
                                >
                                  <app-select
                                    class="v-col-2 pa-0"
                                    item-title="text"
                                    item-value="value"
                                    :items="[
                                      { text: '', value: 0 },
                                      ...bandwidthOptions,
                                    ]"
                                    v-bind="componentField"
                                    :error-messages="errorMessage"
                                    :field-meta="meta"
                                  />
                                </validation-provider>
                                <div class="ml-1 mt-2">{{ unit }}</div>
                              </template>
                            </template>
                          </div>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-badge
                          item="デフォルトポリシー選択"
                          :isInfo="false"
                          :isRequired="false"
                        />
                        <template v-if="!applianceChanged">
                          <span class="ml-3" v-if="!applianceChanged">
                            {{
                              $filter.enumTo(
                                selectedItem.policyType,
                                "policyType"
                              )
                            }}
                          </span>
                        </template>
                        <template v-else>
                          <v-radio-group v-model="form.policyType" hide-details>
                            <v-expansion-panels
                              flat
                              v-model="isCollapsed_OnewaySp"
                            >
                              <v-expansion-panel :value="true">
                                <v-expansion-panel-title
                                  static
                                  class="w-auto pa-0"
                                >
                                  <template #default>
                                    <v-radio
                                      label="編集可能デフォルトポリシー片方向(特定サービス)"
                                      value="ALLOW_SPECIFIC_ONE_WAY"
                                      @click.stop
                                    />
                                  </template>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                  <default-policy-oneway-sp
                                    :appliance-type="form.applianceType"
                                  ></default-policy-oneway-sp>
                                </v-expansion-panel-text>
                              </v-expansion-panel>
                            </v-expansion-panels>

                            <v-expansion-panels
                              flat
                              v-model="isCollapsed_OnewayAny"
                            >
                              <v-expansion-panel :value="true">
                                <v-expansion-panel-title
                                  static
                                  class="w-auto pa-0"
                                >
                                  <template #default>
                                    <v-radio
                                      label="編集可能デフォルトポリシー 片方向(any)"
                                      value="ALLOW_ALL_ONE_WAY"
                                      @click.stop
                                    />
                                  </template>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                  <default-policy-oneway-any
                                    :appliance-type="form.applianceType"
                                  ></default-policy-oneway-any>
                                </v-expansion-panel-text>
                              </v-expansion-panel>
                            </v-expansion-panels>

                            <v-expansion-panels
                              flat
                              v-model="isCollapsed_InteractiveAny"
                            >
                              <v-expansion-panel :value="true">
                                <v-expansion-panel-title
                                  static
                                  class="w-auto pa-0"
                                >
                                  <template #default>
                                    <v-radio
                                      label="編集可能デフォルトポリシー 双方向(any)"
                                      value="ALLOW_ALL_TWO_WAY"
                                      @click.stop
                                    />
                                  </template>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                  <default-policy-interactive-any
                                    :appliance-type="form.applianceType"
                                  ></default-policy-interactive-any>
                                </v-expansion-panel-text>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-radio-group>
                        </template>
                      </v-col>
                    </v-row>
                    <v-row v-if="user.contractSummary.isSecuritySetting">
                      <v-col>
                        <app-label-group
                          label="セキュリティ監視オプション"
                          :value="
                            $filter.enumTo(
                              selectedItem.isSecurityOption,
                              'on_off'
                            )
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
              </v-card>
              <v-card variant="outlined" class="main-card mx-4 mb-4">
                <v-card-title class="py-0 screen-title px-2 ma-4">
                  インターネット契約変更
                </v-card-title>
                <v-card-text>
                  <div class="pa-4">
                    <v-row>
                      <v-col cols="12">
                        <app-label-group label="インターネット帯域">
                          <template #value>
                            <span class="ml-3">
                              <template v-if="form.applianceType === 'IFW'">
                                100Mbpsベストエフォート
                              </template>
                              <template
                                v-if="
                                  form.applianceType === 'UTM' &&
                                  form.contractType === 'BEST_EFFORT'
                                "
                              >
                                1Gbpsベストエフォート
                              </template>
                              <template
                                v-if="
                                  form.applianceType === 'UTM' &&
                                  form.contractType === 'SECURING'
                                "
                              >
                                <template
                                  v-if="
                                    type4Options.bandwidthType !== 'NO_SECURING'
                                  "
                                >
                                  帯域確保型
                                  <template v-if="form.bandwidth!.value > 0">
                                    {{ form.bandwidth!.value
                                    }}{{
                                      $filter.enumTo(
                                        form.bandwidth!.unit,
                                        "bandwidth_unit"
                                      )
                                    }}
                                  </template>
                                </template>
                              </template>
                            </span>
                          </template>
                        </app-label-group>
                      </v-col>
                      <v-col cols="12">
                        <app-label-group label="グローバルIP">
                          <template #value>
                            <div class="pl-3">
                              現在 {{ paidGlobalIpCount }}個 / 上限 32個
                              <br />
                              追加グローバルIP数 :
                              {{ form.numberOfAddGlobalIpAddress }} 個 <br />
                              <app-label-group
                                class="mt-2"
                                label="グローバルIP"
                              >
                                <template #value>
                                  <template
                                    v-for="(
                                      item, index
                                    ) in form.globalIpAddressList"
                                    :key="index"
                                  >
                                    <div class="pl-3 v-row align-center mt-0">
                                      <div class="v-col-6 py-2">
                                        {{ item.globalIpAddress }}
                                        <span v-if="item.isInitialAddress">
                                          (デフォルト)</span
                                        >
                                      </div>
                                      <div class="v-col-2 py-2">
                                        <v-btn
                                          v-if="!item.isInitialAddress"
                                          icon="$mdiMinus"
                                          size="small"
                                          variant="outlined"
                                          rounded="sm"
                                          @click="
                                            removeGlobalIpAddress(
                                              item.globalIpAddressSeq
                                            )
                                          "
                                        >
                                        </v-btn>
                                      </div>
                                    </div>
                                  </template>
                                  <div
                                    v-for="i in form.numberOfAddGlobalIpAddress"
                                    class="v-row pl-3 align-center mt-0"
                                    :key="i"
                                  >
                                    <div class="v-col-6 py-2">
                                      設定完了後にIPが払い出されます
                                    </div>
                                    <div class="v-col-2 py-2">
                                      <v-btn
                                        v-if="canRemove"
                                        icon="$mdiMinus"
                                        size="small"
                                        variant="outlined"
                                        rounded="sm"
                                        @click="
                                          form.numberOfAddGlobalIpAddress!--
                                        "
                                      >
                                      </v-btn>
                                    </div>
                                  </div>
                                </template>
                              </app-label-group>
                              <div class="v-row pl-3">
                                <div class="v-col-6 py-2"></div>
                                <div class="v-col-2 py-2">
                                  <v-btn
                                    size="small"
                                    icon="$mdiPlus"
                                    rounded="sm"
                                    variant="outlined"
                                    :disabled="!canAdd"
                                    @click="form.numberOfAddGlobalIpAddress!++"
                                  >
                                  </v-btn>
                                </div>
                              </div>
                            </div>
                          </template>
                        </app-label-group>
                      </v-col>
                      <v-col cols="12">
                        <app-badge
                          item="M365経路制御オプション"
                          :isRequired="false"
                          :isInfo="false"
                        />
                        <v-radio-group
                          v-model="form.isMicrosoft365"
                          class="ml-3"
                          hide-details
                          inline
                        >
                          <v-radio :value="false" label="OFF" />
                          <v-radio :value="true" label="ON" />
                        </v-radio-group>
                      </v-col>
                      <v-col cols="12">
                        <app-label-group
                          label="状態"
                          :value="$filter.enumTo(selectedItem.status, 'status')"
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
              </v-card>
              <v-card variant="outlined" class="main-card mx-4 mb-4">
                <v-card-title class="py-0 screen-title px-2 ma-4">
                  契約情報
                </v-card-title>
                <v-card-text>
                  <div>契約情報の変更は紙申込でのみ可能です。</div>
                  <div class="pa-4">
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="契約者名"
                          :value="
                            $filter.emptyTo(
                              selectedItem.contractInfo.contractor,
                              '-'
                            )
                          "
                        />
                      </v-col>
                      <v-col cols="12">
                        <app-label-group
                          label="メールアドレス"
                          :value="selectedItem.contractInfo.email"
                        />
                      </v-col>
                      <v-col cols="12">
                        <app-label-group
                          label="エンドユーザ名"
                          :value="selectedItem.contractInfo.endUserName"
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
              </v-card>
              <v-card variant="outlined" class="main-card mx-4 mb-4">
                <v-card-title class="py-0 screen-title px-2 ma-4">
                  保守連絡先情報
                </v-card-title>
                <v-card-text>
                  <div class="pa-4">
                    <!--   コピー元回線番号 -->
                    <app-badge
                      item="コピー元回線番号"
                      :msg="$filter.message('info_maintenance_copy')"
                      :isRequired="false"
                      placement="end"
                    />
                    <v-row>
                      <v-col cols="6">
                        <app-multi-select
                          v-model="selectedUnit"
                          :options="sortFilterType4Items"
                          :custom-label="labelUnit"
                          track-by="wnumberMainAct"
                          hide-details
                          class="mb-2"
                        >
                          <template #beforeList>
                            <div class="multiselect-thead">
                              <p>VPN/VNコード</p>
                              <p>Type4名</p>
                              <p>W番号</p>
                            </div>
                          </template>
                          <template #option="{ option }">
                            <div class="multiselect-tbody">
                              <p>{{ option.vpnVnCode }}</p>
                              <p>{{ option.type4Name }}</p>
                              <p>{{ option.wnumberMainAct }}</p>
                            </div>
                          </template>
                        </app-multi-select>
                        <v-alert
                          v-if="maintenanceInfoErr"
                          density="compact"
                          text="選択された「コピー元回線番号」には、保守連絡先情報が登録されておりません。"
                        />
                      </v-col>
                      <v-col>
                        <v-btn
                          color="primary"
                          @click="setProperty"
                          :disabled="!selectedUnit"
                          >コピー
                        </v-btn>
                      </v-col>
                    </v-row>
                    <!-- 会社名 -->
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          name="company"
                          v-model="form.maintenance.company"
                          label="会社名"
                          :rules="{ required: true, max: { length: 35 } }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-badge
                            item="会社名"
                            :msg="
                              $filter.message('info_max_length', {
                                maxLength: '35',
                              })
                            "
                            placement="end"
                          />
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <!-- 部署名 -->
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          name="department"
                          v-model="form.maintenance.department"
                          label="部署名"
                          :rules="{ required: true, max: { length: 35 } }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-badge
                            item="部署名"
                            :msg="
                              $filter.message('info_max_length', {
                                maxLength: '35',
                              })
                            "
                            placement="end"
                          />
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <!-- 担当者名 -->
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          name="name"
                          v-model="form.maintenance.name"
                          label="担当者名"
                          :rules="{ required: true, max: { length: 20 } }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-badge
                            item="担当者名"
                            :msg="
                              $filter.message('info_max_length', {
                                maxLength: '20',
                              })
                            "
                            placement="end"
                          />
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <!-- 電話番号 -->
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          name="phone"
                          v-model="form.maintenance.phone"
                          label="電話番号"
                          :rules="{
                            required: true,
                            is_phone_number: { max: 11 },
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-badge
                            item="電話番号"
                            :msg="
                              $filter.message('info_tel', {
                                max: '11',
                              })
                            "
                            placement="end"
                          />
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <!-- メールアドレス -->
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          name="email"
                          v-model="form.maintenance.email"
                          label="メールアドレス"
                          :rules="{
                            required: true,
                            max: { length: 127 },
                            is_email: true,
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-badge
                            item="メールアドレス"
                            :msg="
                              $filter.message('info_sign_num_max', {
                                sign: '. _ ! ? { } + - * / = # % $ & ^ ` ~ | @',
                                max: 127,
                              })
                            "
                            placement="end"
                          />
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <!-- 関連項目チェック インターネットType4の契約情報に変更があること-->
            <cross-validation-provider
              :passed="objectChanged"
              vid="no_change"
              class="mt-4"
            >
              {{ $filter.message("no_change_data") }}
            </cross-validation-provider>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" color="primary" variant="flat"
                  >変更
                </v-btn>
                <v-btn @click="cancel" variant="outlined" color="primary"
                  >キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </cross-validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type {
  Bandwidth,
  GlobalIpAddress,
  Maintenance,
  Type4Service,
  Type4ServiceOptions,
  Type4ServicePutRequest,
} from "@/apis/ContractChangeType4Api";
import DefaultPolicyOnewaySp from "@/components/applianceContractSetting/DefaultPolicyOnewaySp.vue";
import DefaultPolicyOnewayAny from "@/components/applianceContractSetting/DefaultPolicyOnewayAny.vue";
import DefaultPolicyInteractiveAny from "@/components/applianceContractSetting/DefaultPolicyInteractiveAny.vue";
import cloneDeep from "lodash/cloneDeep";
import type { ApplianceInfo } from "@/apis/ContractApi";
import AppLabelGroup from "@/components/AppLabelGroup.vue";
import AppFormInput from "@/components/AppFormInput.vue";
import { VueFinalModal } from "vue-final-modal";
import InternetType4ContractModifyConfirm from "@/modals/applianceContractSetting/type4/contract/InternetType4ContractModifyConfirm.vue";

type typeType4ServicePutRequest = Type4ServicePutRequest & {
  globalIpAddressList?: GlobalIpAddress[];
  securityAppliance?: string;
};

export default defineComponent({
  name: "InternetType4ContractModify",
  components: {
    AppFormInput,
    AppLabelGroup,
    DefaultPolicyInteractiveAny,
    DefaultPolicyOnewayAny,
    DefaultPolicyOnewaySp,
  },
  props: {
    selectedItem: {
      type: Object as PropType<Type4Service>,
      required: true,
    },
    type4Items: {
      type: Array as PropType<ApplianceInfo[]>,
      required: true,
    },
  },
  data() {
    return {
      /** 初期通信完了フラグ */
      isLoaded: false,
      user: this.$store.state.user,
      bandwidthOptions: [] as { value: number; text: string }[],
      lowBandwidth: [
        { value: 10, text: " 10 " },
        { value: 20, text: " 20 " },
        { value: 30, text: " 30 " },
        { value: 40, text: " 40 " },
        { value: 50, text: " 50 " },
        { value: 60, text: " 60 " },
        { value: 70, text: " 70 " },
        { value: 80, text: " 80 " },
        { value: 90, text: " 90 " },
        { value: 100, text: " 100 " },
        { value: 200, text: " 200 " },
        { value: 300, text: " 300 " },
        { value: 400, text: " 400 " },
        { value: 500, text: " 500 " },
        { value: 600, text: " 600 " },
        { value: 700, text: " 700 " },
        { value: 800, text: " 800 " },
        { value: 900, text: " 900 " },
        { value: 1000, text: " 1000 " },
      ],
      wideBandwidth: [
        { value: 1, text: " 1 " },
        { value: 2, text: " 2 " },
        { value: 3, text: " 3 " },
        { value: 4, text: " 4 " },
        { value: 5, text: " 5 " },
        { value: 6, text: " 6 " },
        { value: 7, text: " 7 " },
        { value: 8, text: " 8 " },
        { value: 9, text: " 9 " },
        { value: 10, text: " 10 " },
      ],
      unit: "Mbps",
      form: {
        policyType: "ALLOW_SPECIFIC_ONE_WAY" as
          | "ALLOW_SPECIFIC_ONE_WAY"
          | "ALLOW_ALL_ONE_WAY"
          | "ALLOW_ALL_TWO_WAY",
        type4Name: "",
        isMicrosoft365: false,
        maintenance: {
          company: "",
          department: "",
          name: "",
          phone: "",
          email: "",
        } as Maintenance,
        contractType: "BEST_EFFORT" as "BEST_EFFORT" | "SECURING",
        applianceType: "UTM" as "IFW" | "UTM",
        contractType4KeyId: "",
        bandwidth: null as Bandwidth | null,
        numberOfAddGlobalIpAddress: (this.selectedItem.globalIpAddressList
          .length === 0
          ? 1
          : 0) as number | null,
        deleteGlobalIpAddressSeqList: null as string[] | null,
        globalIpAddressList: [] as GlobalIpAddress[],
        securityAppliance: "IFW",
        note: null,
      },
      paidGlobalIpCount: this.selectedItem.globalIpAddressList.length,
      cloneItem: {} as Type4ServicePutRequest,
      isCollapsed_OnewaySp: false,
      isCollapsed_OnewayAny: false,
      isCollapsed_InteractiveAny: false,
      type4Options: {} as Type4ServiceOptions,
      selectedUnit: null as ApplianceInfo | null,
      maintenanceInfoErr: false,
    };
  },
  computed: {
    /** true: 削除可能, false: 削除不可 */
    canRemove(): boolean {
      return (
        this.form.globalIpAddressList.length +
          this.form.numberOfAddGlobalIpAddress! >
        1
      );
    },
    /** true: 追加可能, false: 追加不可 */
    canAdd(): boolean {
      return (
        this.paidGlobalIpCount + this.form.numberOfAddGlobalIpAddress! < 32
      );
    },
    objectChanged(): boolean {
      //帯域確保型以外の場合には、bandwidthを変更検知から除外する
      const bfItem = cloneDeep(this.cloneItem);
      const targetItem = cloneDeep(this.form);
      if (this.form.securityAppliance !== "UTM_SECURING") {
        bfItem.bandwidth = null;
        targetItem.bandwidth = null;
      }
      return this.$crossValidation.objectChanged(bfItem, targetItem);
    },
    /** true: UTM ⇄ IFWの変更あり, false: UTM ⇄ IFWの変更なし */
    applianceChanged(): boolean {
      return this.selectedItem.applianceType !== this.form.applianceType;
    },
    sortFilterType4Items(): ApplianceInfo[] {
      return this.type4Items
        .filter(
          (item) => item.wnumberMainAct !== this.selectedItem.wnumberMainAct
        )
        .sortBy(["vpnVnCode", "asc"]);
    },
  },
  watch: {
    "form.securityAppliance": function (val: string, oldVal: string) {
      switch (val) {
        case "IFW":
          /**
           * 関連項目チェック
           * アプライアンス種別がインターネットFWの場合、契約種別がベストエフォートであること
           * ここで値設定しているので関連項目チェック不要
           */
          this.form.applianceType = "IFW";
          this.form.contractType = "BEST_EFFORT";
          this.form.policyType = this.selectedItem.policyType;
          break;
        case "UTM_BEST_EFFORT":
          this.form.applianceType = "UTM";
          this.form.contractType = "BEST_EFFORT";
          if (oldVal === "IFW") {
            this.form.policyType = this.selectedItem.policyType;
          }
          break;
        case "UTM_SECURING":
          this.form.applianceType = "UTM";
          this.form.contractType = "SECURING";
          if (oldVal === "IFW") {
            this.form.policyType = this.selectedItem.policyType;
          }
          break;
      }
    },
    /** 選択値変更時にエラーメッセージを非表示 */
    selectedUnit() {
      this.maintenanceInfoErr = false;
    },
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    async load() {
      this.type4Options =
        await this.$api.contract_change_type4.getType4ServiceOptions(
          this.selectedItem.type4Id
        );
      if (this.type4Options.bandwidthType === "LOW_BANDWIDTH") {
        this.bandwidthOptions = this.lowBandwidth;
        this.unit = "Mbps";
        this.form.bandwidth = { unit: "MBPS", value: 0 };
      } else if (this.type4Options.bandwidthType === "WIDE_BANDWIDTH") {
        this.bandwidthOptions = this.wideBandwidth.filter(
          (i) =>
            this.type4Options.lowerLimitBandwidth &&
            this.type4Options.upperLimitBandwidth &&
            this.type4Options.lowerLimitBandwidth.value <= i.value &&
            i.value <= this.type4Options.upperLimitBandwidth.value
        );
        this.unit = "Gbps";
        this.form.bandwidth = { unit: "GBPS", value: 0 };
      }
      if (this.selectedItem.applianceType === "IFW") {
        this.form.securityAppliance = "IFW";
      } else {
        if (this.selectedItem.contractType === "BEST_EFFORT") {
          this.form.securityAppliance = "UTM_BEST_EFFORT";
        } else {
          this.form.securityAppliance = "UTM_SECURING";
        }
      }
      this.form.policyType = this.selectedItem.policyType;
      this.form.type4Name = this.selectedItem.type4Name;
      this.form.isMicrosoft365 = this.selectedItem.isMicrosoft365;
      this.form.contractType = this.selectedItem.contractType;
      this.form.applianceType = this.selectedItem.applianceType;
      this.form.contractType4KeyId = this.selectedItem.contractType4KeyId;
      if (this.selectedItem.maintenance) {
        this.form.maintenance.company = this.selectedItem.maintenance.company;
        this.form.maintenance.department =
          this.selectedItem.maintenance.department;
        this.form.maintenance.name = this.selectedItem.maintenance.name;
        this.form.maintenance.phone = this.selectedItem.maintenance.phone;
        this.form.maintenance.email = this.selectedItem.maintenance.email;
      }
      /** bandwidth.unitの変換 */
      if (this.selectedItem.bandwidth) {
        this.form.bandwidth = { ...this.selectedItem.bandwidth };
        /** 低帯域かつunitがGBPSの場合は「Mbps」に変換 */
        if (
          this.type4Options.bandwidthType === "LOW_BANDWIDTH" &&
          this.form.bandwidth.unit === "GBPS"
        ) {
          if (this.form.bandwidth.value === 1) {
            this.form.bandwidth.value = 1000;
            this.form.bandwidth.unit = "MBPS";
          } else {
            this.form.bandwidth.value = 0;
            this.form.bandwidth.unit = "MBPS";
          }
        }
        /** 広帯域かつunitがMBPSの場合は「Gbps」に変換 */
        if (
          this.type4Options.bandwidthType === "WIDE_BANDWIDTH" &&
          this.form.bandwidth.unit === "MBPS"
        ) {
          if (this.form.bandwidth.value === 1000) {
            this.form.bandwidth.value = 1;
            this.form.bandwidth.unit = "GBPS";
          } else {
            this.form.bandwidth.value = 0;
            this.form.bandwidth.unit = "GBPS";
          }
        }
      }
      this.form.globalIpAddressList = this.selectedItem.globalIpAddressList.map(
        (e) => ({ ...e })
      );
      this.cloneItem = cloneDeep(this.form);
    },
    /** 確認モーダルの表示 */
    async submit() {
      await this.$modal.show(InternetType4ContractModifyConfirm, {
        selectedItem: this.selectedItem,
        putItem: this.form,
        globalIpAddressList: this.form.globalIpAddressList,
      });
      /**
       * 関連項目チェック
       * 契約種別が帯域確保の場合、利用帯域が設定されていること。
       * また、 契約種別がベストエフォートの場合、利用帯域が設定されていないこと
       * ここでnull設定しているので関連項目チェック不要
       */
      if (this.form.securityAppliance !== "UTM_SECURING") {
        this.form.bandwidth = null;
      }
      if (this.form.numberOfAddGlobalIpAddress === 0) {
        this.form.numberOfAddGlobalIpAddress = null;
      }
      this.form.note = this.form.note || null;
      // 不要な項目の削除(objectChangeでエラーとなるので値を詰め替えてから削除)
      const postForm: typeType4ServicePutRequest = cloneDeep(this.form);
      delete postForm.securityAppliance;
      delete postForm.globalIpAddressList;
      await this.$api.contract_change_type4.putType4Service(
        this.selectedItem.type4Id,
        postForm
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** 登録済のグローバルIPを削除する
     @param globalIpAddressSeq 登録済のIPアドレスID
     */
    removeGlobalIpAddress(globalIpAddressSeq: string) {
      if (!this.form.deleteGlobalIpAddressSeqList) {
        this.form.deleteGlobalIpAddressSeqList = [];
      }
      this.form.deleteGlobalIpAddressSeqList.push(globalIpAddressSeq);
      const index = this.form.globalIpAddressList.findIndex(
        (e) => e.globalIpAddressSeq === globalIpAddressSeq
      );
      this.form.globalIpAddressList.splice(index, 1);
    },
    labelUnit({ vpnVnCode, type4Name, wnumberMainAct }: ApplianceInfo): string {
      return `${vpnVnCode} / ${type4Name} / ${wnumberMainAct}`;
    },
    async setProperty() {
      if (this.selectedUnit) {
        const setForm = (
          await this.$api.contract_change_type4.getType4Service(
            this.selectedUnit.type4Id!
          )
        ).maintenance;
        if (setForm) {
          this.maintenanceInfoErr = false;
          this.form.maintenance = setForm;
        } else {
          this.maintenanceInfoErr = true;
        }
      }
    },
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-expansion-panel-title:hover > .v-expansion-panel-title__overlay) {
  opacity: 0 !important;
}
:deep(.v-card.v-card--variant-outlined) {
  border-color: rgba(0, 0, 0, 0.125) !important;
}
// WVS2UI-13585 #169 ラジオボタンの編集可能デフォルトポリシーの上方向が見切れている
.v-expansion-panel-title {
  line-height: 1.5;
}
</style>
